import React, { useState, useEffect, useCallback } from 'react';
import '../App.css';
import logo from '../assets/Logo.png';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination, Navigation, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';

import img1 from '../assets/Cell1.webp';
import img2 from '../assets/Cell2.webp';
import img3 from '../assets/Cell3.webp';
import img4 from '../assets/Cell4.webp';
import img5 from '../assets/Cell5.webp';
import img6 from '../assets/Cell6.webp';
import img7 from '../assets/Cell7.webp';
import img8 from '../assets/Cell8.webp';
import img9 from '../assets/Cell9.webp';
import img10 from '../assets/Cell10.webp';
import img11 from '../assets/Cell11.webp';
import img12 from '../assets/Cell12.webp';
import img13 from '../assets/Cell13.webp';
import img14 from '../assets/Cell14.webp';
import img15 from '../assets/Cell15.webp';

const images = [img1, img2, img3, img4, img5, img6, img7, img8, img9, img10, img11, img12, img13, img14, img15];

const swiperStyles = `
  .showcase-swiper {
    width: 100%;
    padding: 40px 0 70px !important;
    position: relative;
  }

  .showcase-swiper .swiper-slide {
    width: 220px !important;
    transition: transform 0.5s cubic-bezier(0.25, 0.46, 0.45, 0.94),
                opacity 0.5s ease,
                filter 0.5s ease;
    opacity: 0.45;
    filter: brightness(0.6) saturate(0.7);
    transform: scale(0.82);
    cursor: pointer;
  }

  .showcase-swiper .swiper-slide-active {
    opacity: 1;
    filter: brightness(1) saturate(1);
    transform: scale(1);
  }

  .showcase-swiper .swiper-slide-prev,
  .showcase-swiper .swiper-slide-next {
    opacity: 0.7;
    filter: brightness(0.8) saturate(0.85);
    transform: scale(0.9);
  }

  .showcase-swiper .swiper-pagination {
    bottom: 16px !important;
  }

  .showcase-swiper .swiper-pagination-bullet {
    width: 6px;
    height: 6px;
    background: rgba(255,255,255,0.35);
    opacity: 1;
    transition: all 0.3s ease;
  }

  .showcase-swiper .swiper-pagination-bullet-active {
    background: #ff7b2c;
    width: 22px;
    border-radius: 3px;
  }

  .showcase-swiper .swiper-button-prev,
  .showcase-swiper .swiper-button-next {
    color: rgba(255,255,255,0.6);
    width: 40px;
    height: 40px;
    background: rgba(255,255,255,0.08);
    border-radius: 50%;
    border: 1px solid rgba(255,255,255,0.12);
    backdrop-filter: blur(8px);
    transition: all 0.25s ease;
    top: 47%;
  }

  .showcase-swiper .swiper-button-prev:hover,
  .showcase-swiper .swiper-button-next:hover {
    background: rgba(255,123,44,0.25);
    border-color: rgba(255,123,44,0.5);
    color: #ff7b2c;
  }

  .showcase-swiper .swiper-button-prev::after,
  .showcase-swiper .swiper-button-next::after {
    font-size: 13px;
    font-weight: 700;
  }

  .phone-frame {
    position: relative;
    border-radius: 36px;
    overflow: hidden;
    box-shadow:
      0 0 0 2px rgba(255,255,255,0.12),
      0 20px 60px rgba(0,0,0,0.6),
      0 4px 20px rgba(0,0,0,0.4);
    background: #111;
  }

  .phone-frame img {
    display: block;
    width: 100%;
    height: auto;
    border-radius: 36px;
  }

  .swiper-slide-active .phone-frame {
    box-shadow:
      0 0 0 2px rgba(255,123,44,0.4),
      0 30px 80px rgba(0,0,0,0.7),
      0 0 60px rgba(255,123,44,0.15);
  }

  /* ── LIGHTBOX ── */
  .lightbox-overlay {
    position: fixed;
    inset: 0;
    z-index: 9999;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(0, 0, 0, 0.92);
    backdrop-filter: blur(18px);
    animation: lbFadeIn 0.25s ease;
  }

  @keyframes lbFadeIn {
    from { opacity: 0; }
    to   { opacity: 1; }
  }

  .lightbox-img-wrap {
    position: relative;
    animation: lbZoomIn 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);
    max-height: 90vh;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  @keyframes lbZoomIn {
    from { transform: scale(0.7); opacity: 0; }
    to   { transform: scale(1);   opacity: 1; }
  }

  .lightbox-img-wrap img {
    max-height: 85vh;
    max-width: 90vw;
    width: auto;
    height: auto;
    border-radius: 36px;
    box-shadow:
      0 0 0 2px rgba(255,123,44,0.4),
      0 40px 100px rgba(0,0,0,0.8);
    display: block;
  }

  .lightbox-close {
    position: fixed;
    top: 20px;
    right: 24px;
    background: rgba(255,255,255,0.1);
    border: 1px solid rgba(255,255,255,0.2);
    color: white;
    border-radius: 50%;
    width: 42px;
    height: 42px;
    font-size: 20px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.2s;
    backdrop-filter: blur(8px);
    z-index: 10000;
  }
  .lightbox-close:hover {
    background: rgba(255,123,44,0.4);
    border-color: rgba(255,123,44,0.6);
    transform: scale(1.1);
  }

  .lightbox-nav {
    position: fixed;
    top: 50%;
    transform: translateY(-50%);
    background: rgba(255,255,255,0.08);
    border: 1px solid rgba(255,255,255,0.15);
    color: rgba(255,255,255,0.8);
    border-radius: 50%;
    width: 48px;
    height: 48px;
    font-size: 20px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.2s;
    backdrop-filter: blur(8px);
    z-index: 10000;
    user-select: none;
  }
  .lightbox-nav:hover {
    background: rgba(255,123,44,0.3);
    border-color: rgba(255,123,44,0.5);
    color: #ff7b2c;
  }
  .lightbox-nav.prev { left: 16px; }
  .lightbox-nav.next { right: 16px; }

  .lightbox-counter {
    position: fixed;
    bottom: 24px;
    left: 50%;
    transform: translateX(-50%);
    font-size: 12px;
    color: rgba(255,255,255,0.4);
    letter-spacing: 3px;
    font-family: 'SF Mono', 'Fira Code', monospace;
    z-index: 10000;
  }

  .phone-frame { cursor: zoom-in; }

  .zoom-hint {
    position: absolute;
    bottom: 10px;
    right: 10px;
    background: rgba(0,0,0,0.55);
    border: 1px solid rgba(255,255,255,0.15);
    border-radius: 20px;
    padding: 4px 10px;
    font-size: 10px;
    color: rgba(255,255,255,0.6);
    letter-spacing: 1px;
    pointer-events: none;
    opacity: 0;
    transition: opacity 0.3s;
    backdrop-filter: blur(4px);
  }
  .swiper-slide-active .zoom-hint {
    opacity: 1;
  }

  .phone-notch {
    position: absolute;
    top: 10px;
    left: 50%;
    transform: translateX(-50%);
    width: 80px;
    height: 22px;
    background: #000;
    border-radius: 0 0 14px 14px;
    z-index: 10;
  }

  .slide-counter {
    position: absolute;
    bottom: -44px;
    left: 50%;
    transform: translateX(-50%);
    font-size: 11px;
    color: rgba(255,255,255,0.3);
    letter-spacing: 2px;
    font-family: 'SF Mono', 'Fira Code', monospace;
    white-space: nowrap;
    opacity: 0;
    transition: opacity 0.3s;
  }

  .swiper-slide-active .slide-counter {
    opacity: 1;
  }
`;

function Landing() {
  const [activeIndex, setActiveIndex] = useState(0);
  const [lightbox, setLightbox] = useState(null); // null | index number

  const openLightbox = useCallback((index) => setLightbox(index), []);
  const closeLightbox = useCallback(() => setLightbox(null), []);
  const prevLightbox = useCallback(() => setLightbox(i => (i - 1 + images.length) % images.length), []);
  const nextLightbox = useCallback(() => setLightbox(i => (i + 1) % images.length), []);

  useEffect(() => {
    if (lightbox === null) return;
    const handler = (e) => {
      if (e.key === 'Escape') closeLightbox();
      if (e.key === 'ArrowLeft') prevLightbox();
      if (e.key === 'ArrowRight') nextLightbox();
    };
    window.addEventListener('keydown', handler);
    document.body.style.overflow = 'hidden';
    return () => {
      window.removeEventListener('keydown', handler);
      document.body.style.overflow = '';
    };
  }, [lightbox, closeLightbox, prevLightbox, nextLightbox]);

  return (
    <div className="App">
      <style>{swiperStyles}</style>

      <div className="upperPage">
        <div className="backgroundImage" />

        {/* Glow ambiental que cambia según el slide */}
        <div
          style={{
            position: 'absolute',
            inset: 0,
            background: 'radial-gradient(ellipse 60% 40% at 50% 60%, rgba(255,123,44,0.07) 0%, transparent 70%)',
            pointerEvents: 'none',
            zIndex: 0,
          }}
        />

        <Swiper
          loop={true}
          centeredSlides={true}
          slidesPerView={'auto'}
          spaceBetween={20}
          grabCursor={true}
          speed={600}
          autoplay={{
            delay: 3500,
            disableOnInteraction: false,
            pauseOnMouseEnter: true,
          }}
          pagination={{ clickable: true }}
          navigation={true}
          modules={[Pagination, Navigation, Autoplay]}
          className="mySwiper showcase-swiper"
          onSlideChange={(swiper) => setActiveIndex(swiper.realIndex)}
          style={{ position: 'relative', zIndex: 1 }}
        >
          {images.map((img, i) => (
            <SwiperSlide key={i}>
              <div className="phone-frame" onClick={() => openLightbox(i)}>
                <div className="phone-notch" />
                <img src={img} alt={`Pantalla ${i + 1}`} />
                <div className="zoom-hint">🔍 ver</div>
              </div>
              <div className="slide-counter">{String(i + 1).padStart(2, '0')} / {String(images.length).padStart(2, '0')}</div>
            </SwiperSlide>
          ))}
        </Swiper>

        {/* LIGHTBOX */}
        {lightbox !== null && (
          <div className="lightbox-overlay" onClick={closeLightbox}>
            <button className="lightbox-close" onClick={closeLightbox}>✕</button>

            <button className="lightbox-nav prev" onClick={(e) => { e.stopPropagation(); prevLightbox(); }}>‹</button>

            <div className="lightbox-img-wrap" onClick={(e) => e.stopPropagation()}>
              <img src={images[lightbox]} alt={`Pantalla ${lightbox + 1}`} />
            </div>

            <button className="lightbox-nav next" onClick={(e) => { e.stopPropagation(); nextLightbox(); }}>›</button>

            <div className="lightbox-counter">
              {String(lightbox + 1).padStart(2, '0')} / {String(images.length).padStart(2, '0')}
            </div>
          </div>
        )}

        <a href="/" className="demoLink">Home</a>
      </div>

      <div className="bottomPage">
        <div className="storeButtons">
          <button className="appleButton"></button>
          <button className="playStoreButton"></button>
        </div>
      </div>

      <footer className="footer">
        <div className="footer-section logo-section">
          <img src={logo} alt="Logo" className="logo" />
        </div>
        <div className="footer-section contact-section">
          <h1 className="footer-title">Contacto</h1>
          <p className="footer-email">chefskills.app@gmail.com</p>
        </div>
        <div className="footer-section credits-section">
          <p>Desarrollado por DarkCainDS – Full-Stack • UX/UI • Infraestructura</p>
          <div className="footer-links">
            <a href="/privacy-policy">Privacidad</a> | <a href="/terms">Términos</a>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default Landing;